import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState: React.FC<{ message?: string }> = ({ message = 'No data for this range.' }) => (
  <div className="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-500">
    <Inbox className="w-8 h-8 mb-2 opacity-50" />
    <p className="text-sm">{message}</p>
  </div>
);

export default EmptyState;
